import { select, call, put } from 'redux-saga/effects';
import { selectUserCredentials, updateUserCredential } from '../../../state/userCredential/userCredentialSlice';
import { applyAuthConfig } from '../../../state/config/configSlice';
import { logoutRequestAction } from '../../logout/action';
import { startTokenRefreshTimerAction } from '../startTokenRefreshTimer/action';
import { backendClient } from '../../../services/api/backend-client';
import { setBugsnagUser } from '../../../services/bugsnag/bugsnag';
import bugsnagClient from '../../../services/bugsnag/bugsnag';
import { getAppVersion, getDeviceId } from '../../../browser/deviceIdentity';

export function* refreshAccessTokenSaga() {

  const appVersion = yield call(getAppVersion);
  try {
    const deviceId = yield call(getDeviceId);

    const { data } = yield call(
      [backendClient, backendClient.post],
      'auth/refresh',
      { appVersion, deviceId, platform: 'web' }
    );
    const { access_token, expires_in, jwt, role, userPreferences, crmEnabled, crmTypes, storageEnabled, storageTypes, defaultCrm, analyticsEnabled, analyticsProcessingEnabled, callIngestion, analyticsMinDuration, callAssistantEnabled, chatAssistantEnabled, domainConfig } = data;
    const expirationTime = Date.now() + expires_in * 1000;

    yield put(updateUserCredential({ access_token, expirationTime, jwt, role, defaultCrm, userPreferences, analyticsProcessingEnabled, callAssistantEnabled, chatAssistantEnabled }));

    yield put(applyAuthConfig({
      callIngestion, analyticsMinDuration, analyticsEnabled,
      crmEnabled, crmTypes, storageEnabled, storageTypes, domainConfig,
    }));
    // Re-sync Bugsnag user in case app restarted
    const { uid, displayName, email } = yield select(selectUserCredentials);
    setBugsnagUser(uid, displayName, email);

    // Restart the token refresh timer
    yield put(startTokenRefreshTimerAction())
    return true;

  } catch (error) {
    const { uid, displayName, email } = yield select(selectUserCredentials);
    console.error('Failed to refresh token:', error);

    // Track this logout trigger with BugSnag
    bugsnagClient.notify(new Error('Logout triggered from refreshAccessTokenSaga'), (event) => {
      event.context = 'refreshAccessTokenSaga';
      event.addMetadata('metadata', {
        source: 'refreshAccessTokenSaga',
        reason: 'Failed to refresh token',
        uid,
        displayName,
        email,
        appVersion,
        errorMessage: error?.message,
        errorStatus: error?.response?.status,
      });
    });

    // Dispatch the logout request action to trigger the logout saga
    yield put(logoutRequestAction());
    return false;
  }
}

